import { faAngleDown, faAngleUp, faCheckCircle, faEdit, faPlus, faTimesCircle, faTrash } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import { Badge, Button, ButtonGroup, Col, Form, InputGroup, Modal, Row, Spinner, Table } from 'react-bootstrap';
import SweetAlert from 'react-bootstrap-sweetalert';
import { connect } from 'react-redux';
import Select from 'react-select';
import { toast } from 'react-toastify';
import { brand_colors } from '../../helpers/brand_colors_helper';
import { handleFormErrors } from '../../helpers/form_helpers';
import { t } from '../../helpers/translation_helper';
import Paginate from '../_partials/Paginate/_Paginate';

// Images
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { GET, POST } from '../../api';
import { colorPalette } from '../../constants/colorsPalette';
import { changeColorOpacity, DDL_ExamstypegrpTypes, DDL_ExamstypegrpTypes2 } from '../../helpers/general_helpers';
import SubjectCard from '../../helpers/SubjectCard';
import { setSubject } from "../../redux/slices/selectedClassSlice";
import { getRegionalStorageURL } from '../../helpers/regional_storage_url_helper';
// Vars
const controller = 'academic-classmain-subject';
const imgDir = 'academic_classmain_subject';

/**
 * Subjects Component
 */
class Subjects extends Component {
  acsDefaults = {
    id: 0,
    name: '',
    code: '',
    coefficient: 0,
    url: '',
    sessionsPerWeek: '',
    acs_credits: 0,
    mandatory: 1,
    status: 1,
    description: '',
    image: '',
    image_prev: '',
    image_deleted: 0,
    totalCoeff: 0,
    subject: 0,
    parent_acs_id_flag: 0,
    parent_acs_id: null,
    subjectsSessions: 0,
    learnarea_ids: [],
    gradeslevel: [],
    term_linked_agegroup_assessment: {
      term_d_1: '0.00',
      term_d_2: '0.00',
      term_d_3: '0.00',
      term_d_4: '0.00',
      details: []
    },
    gradebook_subjects: [],
    selectedGrades: [],
    report_card_appearance: 1,
    specific_priority: 0,
  }
  gradesLevelExtraDefaults = {
    gle_id: 0,
    gle_points: '',
    gle_percentage: '',
    gle_isd_grade: ''
  }

  //  States
  state = {
    DDL_examstypegrp_types: DDL_ExamstypegrpTypes(),
    DDL_examstypegrp_types2: DDL_ExamstypegrpTypes2(),
    examstypegrp: {
      selected: null,
      data: []
    },
    progassData: [],
    learnareaData: [],
    deleteModal: { show: false, id: 0, action: () => { }, title: null, desc: null },
    formTabs: {
      active: { name: 'Information' },
      data: [
        { id: 'tab_information', name: 'Information' },
        { id: 'tab_marks_percentage', name: 'Marks Percentage', link: 'exam-groups-types?activeTab=exam-groups-types-4' },
        { id: 'tab_marks_definition', name: 'Marks Definition', link: '' },
        { id: 'tab_subject_strands', name: 'Subject Strands', link: '' },
        { id: 'tab_curriculum_strands', name: 'Curriculum Strands', link: '' },
      ]
    },
    working: false,
    editing: false,
    showPicker: false,

    limit: 50,
    totalRecords: 0,
    academicClassmainSubjects: null,
    academicSubjectsList: [],
    academicClassmainSubjectsDDL: [],
    // Form fields
    showAddEditForm: false,
    acsFormData: { ...this.acsDefaults },
    replicating: false,
    confirmAlert: {
      show: false,
      action: () => null
    }
  };

  /**
   * Constructor
   */
  constructor() {
    super();
    this.image = React.createRef();
  }

  /**
   * Component Did Mount
   */
  componentDidMount() {
    this.getAcademicClassmainSubjects();
    this.getAcademicSubjects();
    this.getParentAcademicClassmainSubjects();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.selectedClass) {
      if (prevProps.selectedClass.class.class_id != this.props.selectedClass.class.class_id) {
        this.getAcademicClassmainSubjects()
      }
    }

    if (this.props.showAddEditForm != prevProps.showAddEditForm && this.props.showAddEditForm) {
      this.handleAddEditFormOpen()
    }

  }

  /**
   * Get Subjects
   */
  getAcademicClassmainSubjects = async (limit = this.state.limit, offset = 0) => {
    this.setState({
      academicClassmainSubjects: null
    });

    const { authData, selectedClass } = this.props;
    const { auth_key, user_id, role_id } = authData.loginData;
    const { employee_id } = authData.userData;
    const { center_id } = authData.centerData;
    let agegroup_id = (selectedClass) ? selectedClass.class.agegroup_id : null;
    let class_id = (selectedClass) ? selectedClass.class.class_id : null;
    if (this.props.agegroup_id) {
      agegroup_id = this.props.agegroup_id
    }

    const fData = new FormData();
    fData.append('center_id', center_id);
    fData.append('agegroup_id', agegroup_id);
    fData.append('class_id', class_id);
    fData.append('employee_id', employee_id);
    fData.append('user_id', user_id);
    fData.append('role_id', role_id);
    fData.append('limit', limit);
    fData.append('offset', offset);
    fData.append('orderParentChildren', 1);


    if (this.getAcademicClassmainSubjectsReq) {
      this.getAcademicClassmainSubjectsReq.abort()
    }
    this.getAcademicClassmainSubjectsReq = new AbortController();
    try {
      const res = await POST(controller + '/get', fData, {
        signal: this.getAcademicClassmainSubjectsReq.signal
      });
      if (res.status == 200) {

        this.setState({
          academicClassmainSubjects: res.data.data,
          totalRecords: parseInt(res.data.total_count),
          subjectsSessions: res.data.data
            .filter(item => !item.parent_acs_id)
            .reduce((acc, obj) => acc + obj.acs_sessions_per_week, 0)
        });
      }
    } catch (err) {
      console.log('err', err)
      toast.error(t('Something went wrong while fetching subjects!'));

    }
  };

  /**
   * Get Academic Subjects
   */
  getAcademicSubjects = async () => {
    const { authData } = this.props;
    const { auth_key } = authData.loginData;
    const { center_id } = authData.centerData;

    try {
      const res = await GET(controller + '/get-academic-subjects', {
        params: {
          center_id,
          auth_key,
          appname: process.env.REACT_APP_NAME,
        },
      });

      if (res.status == 200) {
        this.setState({
          academicSubjectsList: res.data.map((item) => {
            return {
              ...item,
              value: item.as_id,
              label: item.as_name,//+ ' (' + item.ab_name + ')'
            };
          }),
        });
      }
    } catch (err) {
      console.log('err', err)
      toast.error(t('Something went wrong while fetching academic subjects!'));

    }
  };

  getParentAcademicClassmainSubjects = async (editingData_acs_id) => {
    const { selectedClass } = this.props;
    let agegroup_id = (selectedClass) ? selectedClass.class.agegroup_id : null;
    if (this.props.agegroup_id) {
      agegroup_id = this.props.agegroup_id
    }

    try {
      if (this.getParentAcademicClassmainSubjectsReq) {
        this.getParentAcademicClassmainSubjectsReq.abort();
      }
      this.getParentAcademicClassmainSubjectsReq = new AbortController();
      let res = await GET(controller + '/get-parent-academic-classmain-subjects', {
        params: { agegroup_id },
        signal: this.getParentAcademicClassmainSubjectsReq.signal,
      })



      let academicClassmainSubjectsDDL = []
      res.data.map((v, i) => {
        if (editingData_acs_id != v.acs_id) {
          academicClassmainSubjectsDDL.push({
            label: v.acs_name,
            value: v.acs_id,
          })
        }
      })
      this.setState({
        academicClassmainSubjectsDDL
      });
    } catch (err) {
      console.log('err', err)
      toast.error(t('Something went wrong while fetching academic subjects!'));

    }
  };

  /**
   * Get Total Coefficient
   */
  getTotalCoefficient = async (as_id) => {
    const { selectedClass } = this.props;
    let agegroup_id = (selectedClass) ? selectedClass.class : null;
    if (this.props.agegroup_id) {
      agegroup_id = this.props.agegroup_id
    }

    try {
      const res = await GET(controller + '/get-total-coefficient', {
        params: {
          agegroup_id,
          as_id,
        },
      });

      if (res.status == 200) {
        this.setState({
          acsFormData: {
            ...this.state.acsFormData,
            totalCoeff: res.data.total_acs_coefficient,
          }
        });
      }
    } catch (err) {
      console.log('err', err)
      toast.error(t('Something went wrong while fetching total coefficient!'));

    }
  };

  /**
   * On Change Academic Subject
   * @param {Object} obj
   */
  onChangeAcademicSubject = (obj) => {
    this.setState({ acsFormData: { ...this.state.acsFormData, subject: obj } }, () => this.getTotalCoefficient(obj.value));
  };

  /**
   * On Change Coefficient
   * @param {Event} event
   */
  onChangeCoeff = (event) => {
    const coefficient = parseInt(event.target.value);
    const { totalCoeff } = this.state.acsFormData;
    console.log(coefficient, totalCoeff, (parseFloat(totalCoeff) + parseFloat(coefficient)));

    if ((parseFloat(totalCoeff) + parseFloat(coefficient)) > 100) {
      toast.error(t('Already used remaining coefficient!'));
    } else {
      this.setState({ acsFormData: { ...this.state.acsFormData, coefficient: coefficient } });
    }
  };

  /**
   * Handle Add / Edit form
   */
  handleAddEditFormOpen = async (isEditing = false, editingData = {}) => {

    const regionalStorageURL = getRegionalStorageURL(this.props.authData.centerData.tenant_id);

    // If Editing
    if (isEditing) {
      const { academicSubjectsList } = this.state;

      const subject = academicSubjectsList.find((item) => {
        return item.value == editingData.as_id;
      });

      if (editingData.parent_acs_id) {
        editingData.parent_acs_id = this.state.academicClassmainSubjectsDDL.find((v, i) => v.value == editingData.parent_acs_id)
      }
      console.log('editingData', editingData);

      let res = await GET(controller + '/edit-acs', {
        params: {
          acs_id: editingData.acs_id,
          agegroup_id: editingData.agegroup_id,
        }
      })
      let resData = res.data

      let term_linked_agegroup_assessment = resData.term_linked_agegroup_assessment
      if (term_linked_agegroup_assessment.details) {
        term_linked_agegroup_assessment.details = term_linked_agegroup_assessment.details.map((v, i) => {
          let f_tlasd = resData.examstypegrp.find((vv, ii) => vv.examstypegrp_id == v.examstypegrp_id && vv.examstype_id == v.examstype_id)
          return { ...v, ...f_tlasd }
        })
      }
      this.setState({
        acsFormData: {
          ...this.acsDefaults,
          ...editingData,
          id: editingData.acs_id,
          name: editingData.acs_name,
          code: editingData.acs_code,
          coefficient: parseInt(editingData.acs_coefficient),
          url: editingData.acs_url,
          sessionsPerWeek: editingData.acs_sessions_per_week,
          acs_credits: editingData.acs_credits,
          mandatory: parseInt(editingData.acs_mandatory),
          parent_acs_id: editingData.parent_acs_id,
          parent_acs_id_flag: (editingData.parent_acs_id) ? 1 : 0,
          status: parseInt(editingData.acs_status),
          description: editingData.acs_desc || '',
          image: editingData.acs_image,
          image_prev: (editingData.acs_image) ? regionalStorageURL + this.props.authData.centerData.center_uuid + '/' + imgDir + '/' + editingData.acs_image : '',
          subject,
          term_linked_agegroup_assessment,
          learnarea_ids: JSON.parse(editingData.learnarea_ids),
          gradeslevel: resData.gradeslevel,
          term_linked_agegroup_assessment: resData.term_linked_agegroup_assessment,
          gradebook_subjects: resData.gradebook_subjects,
        },
        editing: isEditing,
        showAddEditForm: true,
        formTabs: {
          ...this.state.formTabs,
          active: this.state.formTabs.data[0]
        },
        examstypegrp: {
          data: resData.examstypegrp.map(item => {
            return {
              ...item,
              value: item.examstype_id,
              label: item.examstype_name
            }
          }), selected: null
        },
        progassData: resData.progass,
        learnareaData: resData.learnarea,
        centerlic_year: resData.centerlic_year
      });
    } else {

      let res = await GET(controller + '/edit-acs', {})
      let resData = res.data

      let agegroup_id = (this.props.selectedClass) ? this.props.selectedClass.class : null;
      if (this.props.agegroup_id) {
        agegroup_id = this.props.agegroup_id
      }
      this.setState({
        acsFormData: {
          ...this.acsDefaults,
          agegroup_id,
        },
        editing: isEditing,
        showAddEditForm: true,
        formTabs: {
          ...this.state.formTabs,
          active: this.state.formTabs.data[0]
        },
        examstypegrp: {
          data: resData.examstypegrp.map(item => {
            return {
              ...item,
              value: item.examstype_id,
              label: item.examstype_name
            }
          }), selected: null
        },
        progassData: resData.progass,
        learnareaData: resData.learnarea,
      });
    }
    this.getParentAcademicClassmainSubjects(editingData.acs_id)
  };
  handleAddEditFormClose = () => {
    this.setState({
      // acsFormData: {
      //   ...this.acsDefaults,
      // },
      showAddEditForm: false,
      selectedGrades: []
    });
  };

  /**
   * Preview Upload File
   * @returns
   */
  previewFile = (e) => {
    const reader = new FileReader();

    const selectedFile = e.target.files[0];

    if (selectedFile) {
      reader.readAsDataURL(selectedFile);
    }

    if (!selectedFile.type.includes('image')) {
      toast.error(t('Only image file is allowed!'));
      return;
    }

    reader.onload = (readerEvent) => {
      this.setState({
        acsFormData: {
          ...this.state.acsFormData,
          [e.target.name + '_deleted']: 0,
          [e.target.name + '_prev']: readerEvent.target.result,
          [e.target.name]: e.target.files[0],
        }
      });
    };
  };

  openColorPicker = () => {
    this.setState({
      showPicker: !this.state.showPicker,
    });
  };

  closeColorPicker = () => {
    this.setState({
      showPicker: false,
    });
  };

  onChangeColor = (color) => {
    this.setState({
      color: color.rgb,
    });
  };



  /**
   * Insert
   */
  insert = async () => {
    this.setState({ working: true });

    let { acsFormData } = this.state;
    const { authData, selectedClass } = this.props;
    const { auth_key, user_id } = authData.loginData;
    const { center_id, center_timezone } = authData.centerData;

    if (acsFormData.parent_acs_id_flag) {
      acsFormData.parent_acs_id = (acsFormData.parent_acs_id) ? acsFormData.parent_acs_id.value : null
    } else {
      acsFormData.parent_acs_id = null
    }

    let AcademicClassmainSubjectData = {
      agegroup_id: acsFormData.agegroup_id,
      as_id: acsFormData.subject.value,
      acs_name: acsFormData.name,
      acs_code: acsFormData.code,
      acs_coefficient: acsFormData.coefficient,
      acs_url: acsFormData.url,
      acs_desc: acsFormData.description,
      acs_sessions_per_week: acsFormData.sessionsPerWeek,
      acs_credits: acsFormData.acs_credits,
      acs_mandatory: (acsFormData.mandatory) ? 1 : 0,
      parent_acs_id: acsFormData.parent_acs_id,
      acs_status: (acsFormData.status) ? 1 : 0,
      gradeslevel: acsFormData.gradeslevel,
      term_linked_agegroup_assessment: acsFormData.term_linked_agegroup_assessment,
      gradebook_subjects: acsFormData.gradebook_subjects,
      learnarea_ids: acsFormData.learnarea_ids,
      report_card_appearance: (acsFormData.report_card_appearance) ? 1 : 0,
      specific_priority: (acsFormData.specific_priority) ? 1 : 0,
    }

    const fData = new FormData();
    fData.append('center_id', center_id);
    fData.append('center_timezone', center_timezone);
    fData.append('user_id', user_id);
    fData.append('AcademicClassmainSubjectData', JSON.stringify(AcademicClassmainSubjectData));
    fData.append('acs_id', acsFormData.id);
    fData.append('acs_image', acsFormData.image);
    fData.append('acs_image_deleted', acsFormData.image_deleted);

    try {
      const res = await POST(controller + '/save', fData, {

      });

      if (res.status == 200) {
        if (res.data.type) {
          this.handleAddEditFormClose();
          this.getAcademicClassmainSubjects();
          this.setState({ working: false });
          toast[res.data.messageType](t(res.data.message));
        } else {
          if (res.data.data != null) {
            handleFormErrors(res.data.data);
          } else {
            toast[res.data.messageType](t(res.data.message));
          }
          this.setState({ working: false });
        }
      }
    } catch (err) {
      console.log('err', err)
      toast.error(t('Something went wrong while adding subject!'));

      this.setState({ working: false });
    }
  };

  /**
   * Update
   */
  update = async () => {
    this.setState({ working: true });
    let { acsFormData } = this.state;

    const { authData, selectedClass } = this.props;
    const { auth_key, user_id } = authData.loginData;
    const { center_id, center_timezone } = authData.centerData;
    let agegroup_id = (selectedClass) ? selectedClass.class : null;
    if (this.props.agegroup_id) {
      agegroup_id = this.props.agegroup_id
    }
    if (acsFormData.parent_acs_id_flag) {
      acsFormData.parent_acs_id = (acsFormData.parent_acs_id) ? acsFormData.parent_acs_id.value : null
    } else {
      acsFormData.parent_acs_id = null
    }

    let AcademicClassmainSubjectData = {
      agegroup_id: acsFormData.agegroup_id,
      as_id: acsFormData.subject.value,
      acs_name: acsFormData.name,
      acs_code: acsFormData.code,
      acs_coefficient: acsFormData.coefficient,
      acs_url: acsFormData.url,
      acs_desc: acsFormData.description,
      acs_sessions_per_week: acsFormData.sessionsPerWeek,
      acs_credits: acsFormData.acs_credits,
      acs_mandatory: acsFormData.mandatory,
      parent_acs_id: acsFormData.parent_acs_id,
      acs_status: acsFormData.status,
    }
    const fData = new FormData();
    fData.append('center_id', center_id);
    fData.append('center_timezone', center_timezone);
    fData.append('user_id', user_id);
    fData.append('acs_id', acsFormData.id);
    fData.append('AcademicClassmainSubjectData', JSON.stringify(AcademicClassmainSubjectData));
    fData.append('acs_image', acsFormData.image);
    fData.append('acs_image_deleted', acsFormData.image_deleted);

    try {
      const res = await POST(controller + '/update', fData, {

      });
      if (res.status == 200) {
        if (res.data.messageType !== 'error') {
          this.handleAddEditFormClose();
          this.getAcademicClassmainSubjects();
          this.setState({ working: false });
        } else {
          handleFormErrors(res.data.data);
          this.setState({ working: false });
        }
      }
    } catch (err) {
      console.log('err', err)
      toast.error(t('Something went wrong while updating subject!'));

      this.setState({ working: false });
    }
  };

  /**
   * Delete
   */
  delete = async () => {
    const acs_id = this.state.deleteModal.id;

    try {
      const res = await GET(controller + '/delete', {
        params: {
          acs_id
        }
      });


      if (res.data.type) {
        this.setState({
          deleteModal: {
            ...this.state.deleteModal,
            show: false,
            id: 0
          }
        });
        this.getAcademicClassmainSubjects();
      }

      toast.error(t(res.data.message));
    } catch (err) {
      console.log(err);
    }
  }

  setAcsFormData = (column, value) => {
    let { acsFormData } = this.state
    this.setState({ acsFormData: { ...acsFormData, [column]: value } })
  }

  setGradesLevel = (index, column, value) => {
    let { acsFormData } = this.state
    acsFormData.gradeslevel[index][column] = value
    this.setState({ acsFormData })
  }

  setGradesLevelExtra = (gradeslevel_index, index, column, value) => {
    let { acsFormData } = this.state
    acsFormData.gradeslevel[gradeslevel_index].gradeslevel_extra[index][column] = value
    this.setState({ acsFormData })
  }

  setTermLinkedAgegroupAssessmentDetail = (index, column, value) => {
    let { acsFormData } = this.state
    acsFormData.term_linked_agegroup_assessment.details[index][column] = value
    this.setState({ acsFormData })
  }

  setGradebookSubject = (index, column, value) => {
    let { acsFormData } = this.state
    acsFormData.gradebook_subjects[index][column] = value
    this.setState({ acsFormData })
  }

  renderGradeslevel = () => {
    let { acsFormData } = this.state;
    const { AgeGroupData } = this.props;
    return <div>
      <h5>{t('Grade Selection & Replication')}</h5>
      {this.state.editing &&
        <Row className='mb-3'>
          <Col className='pe-0 position-relative'>
            <button style={{
              fontSize: 10,
              fontWeight: 'bold',
              borderRadius: 10,
              position: 'absolute',
              right: 7,
              top: 7,
              zIndex: 9999,
            }}
              onClick={() => {
                this.setState({
                  acsFormData: {
                    ...acsFormData,
                    selectedGrades: this.props.AgeGroupData.map(item => {
                      return {
                        ...item,
                        value: item.agegroup_id,
                        label: item.agegroup_code
                      }
                    })
                  },
                });
              }}
              className='btn btn-sm btn-outline-success'>SELECT ALL</button>
            <Select
              placeholder={t('Select Grades')}
              isMulti={true}
              closeMenuOnSelect={false}
              value={this.state.acsFormData.selectedGrades}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999
                }),
                control: styles => ({
                  ...styles,
                  paddingRight: 75
                }),
              }}
              options={this.props.AgeGroupData.map(item => {
                return {
                  ...item,
                  value: item.agegroup_id,
                  label: item.agegroup_code
                }
              })}
              onChange={(obj) => {
                this.setState({
                  acsFormData: {
                    ...acsFormData,
                    selectedGrades: obj
                  }
                });
              }}
            />
          </Col>
          <Col md={'auto'}>
            <Button disabled={acsFormData.selectedGrades.length == 0 || this.state.replicating} variant="success" size="sm" style={{ height: 38 }}
              onClick={() => this.setState({
                confirmAlert: {
                  show: true,
                  action: () => this.replicateMarksDef()
                }
              })}>{t('Replicate for Selected Grades')}
            </Button>
          </Col>
        </Row>
      }
      {/* {this.state.editing &&
        <Row className='mb-3 mt-4'>
          <Col className='pe-0 position-relative'>
            <button style={{
              fontSize: 10,
              fontWeight: 'bold',
              borderRadius: 10,
              position: 'absolute',
              right: 30,
              top: -15,
              zIndex: 9999,
            }}
              onClick={() => {
                this.setState({
                  acsFormData: {
                    ...acsFormData,
                    selectedGrades: this.props.AgeGroupData.map(item => {
                      return {
                        ...item,
                        value: item.agegroup_id,
                        label: item.agegroup_code
                      }
                    })
                  },
                });
              }}
              className='btn btn-sm btn-warning'>SELECT ALL</button>
            <Select
              placeholder={t('Select Grades')}
              isMulti={true}
              closeMenuOnSelect={false}
              value={this.state.acsFormData.selectedGrades}
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999, }), }}
              options={this.props.AgeGroupData.map(item => {
                return {
                  ...item,
                  value: item.agegroup_id,
                  label: item.agegroup_code
                }
              })}
              onChange={(obj) => {
                this.setState({
                  acsFormData: {
                    ...acsFormData,
                    selectedGrades: obj
                  }
                });
              }}
            />
          </Col>
          <Col md={'auto'}>
            <Button disabled={acsFormData.selectedGrades.length == 0 || this.state.replicating}
              style={{ height: 38 }} variant='info' size="sm" onClick={
                () => this.setState({
                  confirmAlert: {
                    show: true,
                    action: () => this.replicateMarksDef()
                  }
                })
              }>{t('Replicate for Selected Grades')}
            </Button>
          </Col>
        </Row>
      } */}

      {acsFormData.gradeslevel.map((v, i) => {
        return <div key={i} className='d-flex flex-column my-3 border p-2'>
          <div className='d-flex flex-row align-items-center'>
            <Form.Group className="me-3" >
              <Form.Label>{t('Color')}</Form.Label>
              <div className='selected-color' onClick={() => this.setGradesLevel(i, 'open_colorpicker', true)}>
                <div style={{ backgroundColor: v.gradeslevel_color }}></div>
              </div>
              {v.open_colorpicker &&
                <div className='color-palette'>
                  {colorPalette.map((color, color_i) => (
                    <div
                      key={color_i}
                      onClick={() => {
                        acsFormData.gradeslevel[i]['open_colorpicker'] = false
                        acsFormData.gradeslevel[i]['gradeslevel_color'] = color.code
                        this.setState({ acsFormData })
                      }}
                      style={{ backgroundColor: color.code }}
                    ></div>
                  ))}
                </div>
              }
            </Form.Group>
            <Form.Group className="me-3">
              <Form.Label>{t('Name')}</Form.Label>
              <Form.Control type="text"
                defaultValue={v.gradeslevel_name}
                onChange={(e) => this.setGradesLevel(i, 'gradeslevel_name', e.target.value)} />
            </Form.Group>
            <Form.Group className="me-3">
              <Form.Label>{t('Abbreviation')}</Form.Label>
              <Form.Control type="text"
                defaultValue={v.gradeslevel_code}
                onChange={(e) => this.setGradesLevel(i, 'gradeslevel_code', e.target.value)} />
            </Form.Group>
            <Form.Group className="me-3">
              <Form.Label>{t('Marks From')}</Form.Label>
              <Form.Control type="text"
                defaultValue={v.gradeslevel_from}
                onChange={(e) => this.setGradesLevel(i, 'gradeslevel_from', e.target.value)} />
            </Form.Group>
            <Form.Group className="me-3">
              <Form.Label>{t('Marks To')}</Form.Label>
              <Form.Control type="text"
                defaultValue={v.gradeslevel_to}
                onChange={(e) => this.setGradesLevel(i, 'gradeslevel_to', e.target.value)} />
            </Form.Group>
            <Form.Group>
              <Form.Label>{t('Grade')}</Form.Label>
              <Form.Control type="text"
                defaultValue={v.gradeslevel_grade}
                onChange={(e) => this.setGradesLevel(i, 'gradeslevel_grade', e.target.value)} />
            </Form.Group>
          </div>
          <div className='d-flex flex-row' >
            <Form.Group style={{ width: '100%' }}>
              <Form.Label>{t('Description')}</Form.Label>
              <Form.Control as="textarea" rows={2}
                defaultValue={v.gradeslevel_desc}
                onChange={(e) => this.setGradesLevel(i, 'gradeslevel_desc', e.target.value)} />
            </Form.Group>
          </div>
          <div className='d-flex flex-column px-2 py-1 mt-3' style={{ borderRadius: 5, backgroundColor: '#F5F5F5' }}>
            <div className='d-flex flex-row align-items-center justify-content-between'>
              <div>ISD Table</div>
              <div className='d-flex flex-row align-items-center'>
                <Button variant='outline-info' size='sm' className='me-3' onClick={() => {
                  acsFormData.gradeslevel[i].gradeslevel_extra.push({ ...this.gradesLevelExtraDefaults })
                  this.setState({
                    acsFormData,
                  }, () => {
                    this.setGradesLevel(i, 'open_extra', true)
                  })
                }}>
                  {t('Add Item')}{' '}
                  <FontAwesomeIcon icon={faPlus} />
                </Button>
                <Button variant='outline-success' size='sm' onClick={() => this.setGradesLevel(i, 'open_extra', !v.open_extra)}>
                  <FontAwesomeIcon icon={(v.open_extra) ? faAngleUp : faAngleDown} />
                </Button>
              </div>
            </div>
            {v.open_extra && (!v.gradeslevel_extra || v.gradeslevel_extra.length <= 0) &&
              <div className='d-flex flex-row my-1 p-2 justify-content-center align-items-center' style={{ borderRadius: 5, backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8 }}>
                {t('No data added yet')}
              </div>
            }
            {v.open_extra && v.gradeslevel_extra && v.gradeslevel_extra.map((vv, ii) => {
              return <div className='d-flex flex-row my-1 p-2' style={{ borderRadius: 5, backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8 }}>
                <Form.Group style={{ flex: 1 }} className="me-3">
                  <Form.Label>{t('Points')}</Form.Label>
                  <Form.Control type="text"
                    placeholder={t('Points')}
                    value={vv.gle_points}
                    onChange={(e) => this.setGradesLevelExtra(i, ii, 'gle_points', e.target.value)} />
                </Form.Group>
                <Form.Group style={{ flex: 1 }} className="me-3">
                  <Form.Label>{t('Percentage')}</Form.Label>
                  <Form.Control type="text"
                    placeholder={t('Percentage')}
                    value={vv.gle_percentage}
                    onChange={(e) => this.setGradesLevelExtra(i, ii, 'gle_percentage', e.target.value)} />
                </Form.Group>
                <Form.Group style={{ flex: 1 }} className="me-3">
                  <Form.Label>{t('ISD Grade')}</Form.Label>
                  <Form.Control type="text"
                    placeholder={t('ISD Grade')}
                    value={vv.gle_isd_grade}
                    onChange={(e) => this.setGradesLevelExtra(i, ii, 'gle_isd_grade', e.target.value)} />
                </Form.Group>
                <Button variant='outline-danger' size='sm' onClick={() => {
                  acsFormData.gradeslevel[i]['gradeslevel_extra'].splice(ii, 1)
                  this.setState({ acsFormData })
                }}>
                  <FontAwesomeIcon icon={faTrash} />
                </Button>
              </div>
            })}
          </div>
          <div className='d-flex flex-row mt-2'>
            <Button variant='danger' size="sm" style={{ width: 100 }} onClick={() => {
              acsFormData.gradeslevel.splice(i, 1)
              this.setState({ acsFormData })
            }}>
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          </div>
        </div>

      })}
      <div className='mt-3'>
        <Button variant='outline-info' style={{ width: '100%' }} onClick={() => {
          acsFormData.gradeslevel.push({
            gradeslevel_id: '',
            gradeslevel_from: '',
            gradeslevel_to: '',
            gradeslevel_color: '',
            gradeslevel_name: '',
            gradeslevel_desc: '',
            gradeslevel_code: '',
            gradeslevel_grade: '',
            open_colorpicker: false,
            open_extra: false,
            gradeslevel_extra: [],
          })
          this.setState({ acsFormData })
        }}>
          {t('Add New')}{' '}
          <FontAwesomeIcon icon={faPlus} />
        </Button>
      </div>
    </div >
  }

  renderStrands = () => {
    let { acsFormData, progassData, learnareaData } = this.state

    return <div>
      <h5>Curriculum Strands</h5>
      <div className="d-flex flex-row">
        <div className='p-2 me-3' style={{ backgroundColor: '#f2f2f2', borderRadius: 5, flex: 2, fontSize: 12 }}>
          {progassData.map((v, i) => {
            return <div key={i} className="p-1 mb-2 cursor-pointer" style={{ backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, borderRadius: 5 }} >
              <div className='d-flex flex-row justify-content-between p-2' onClick={() => {
                progassData[i].open = (progassData[i].open) ? false : true
                this.setState({ progassData })
              }}>
                <div>{v.progass_code}</div>
                <div>
                  <FontAwesomeIcon icon={(v.open) ? faAngleUp : faAngleDown} />
                </div>
              </div>
              {v.open &&
                <div className='border-top'>
                  {learnareaData.map((vv, ii) => {
                    if (vv.progass_id != v.progass_id) {
                      return null
                    }
                    let selected_leranarea = acsFormData.learnarea_ids.findIndex((vvv) => vvv == vv.learnarea_id)
                    return <div key={ii} className='p-2 d-flex flex-row cursor-pointer' onClick={() => {
                      if (selected_leranarea !== -1) {
                        acsFormData.learnarea_ids.splice(selected_leranarea, 1)
                      } else {
                        acsFormData.learnarea_ids.push(vv.learnarea_id)
                      }
                      this.setState({ acsFormData })
                    }}>
                      <div className='me-2'>
                        <FontAwesomeIcon icon={(selected_leranarea !== -1) ? faCheckCircle : faCircle} style={{ color: brand_colors[this.props.defaultTheme.theme_id].color1 }} />
                      </div>
                      <div className='d-flex flex-row flex-wrap'>
                        <div style={{ fontWeight: 600 }}>{vv.learnarea_code}</div> : {vv.learnarea_desc}
                      </div>
                    </div>
                  })}
                </div>
              }
            </div>
          })}
        </div>
        <div className='p-2' style={{ backgroundColor: '#f2f2f2', borderRadius: 5, flex: 1 }}>
          {progassData.map((v, i) => {

            let findChildren = learnareaData.filter((vv, ii) => {
              if (vv.progass_id == v.progass_id) {
                return acsFormData.learnarea_ids.find((vvv) => vvv == vv.learnarea_id)
              }
              return false
            })
            if (findChildren.length <= 0) {
              return null
            }

            return <div key={i} className="p-1 mb-2 cursor-pointer" style={{ fontSize: 12 }} >
              <div className='d-flex flex-row justify-content-between p-2'>
                <div>{v.progass_code}</div>
              </div>
              <div style={{ backgroundColor: brand_colors[this.props.defaultTheme.theme_id].color8, borderRadius: 5, }} >
                {learnareaData.map((vv, ii) => {
                  if (vv.progass_id != v.progass_id) {
                    return null
                  }
                  let selected_leranarea = acsFormData.learnarea_ids.findIndex((vvv) => vvv == vv.learnarea_id)
                  if (selected_leranarea === -1) {
                    return null
                  }
                  return <div key={ii} className='p-2 d-flex flex-row cursor-pointer' >
                    <div className='me-2' onClick={() => {
                      if (selected_leranarea !== -1) {
                        acsFormData.learnarea_ids.splice(selected_leranarea, 1)
                      } else {
                        acsFormData.learnarea_ids.push(vv.learnarea_id)
                      }
                      this.setState({ acsFormData })
                    }}>
                      <FontAwesomeIcon icon={faTrash} style={{ color: brand_colors[this.props.defaultTheme.theme_id].color11 }} />
                    </div>
                    <div className='d-flex flex-row flex-wrap'>
                      <div style={{ fontWeight: 600 }}>{vv.learnarea_code}</div> : {vv.learnarea_desc}
                    </div>
                  </div>
                })}
              </div>
            </div>
          })}
        </div>
      </div>

    </div>


    return <div>
      <div className='d-flex flex-column border'>
        {progassData.map((v, i) => {
          return <div key={i} style={{ width: '50%' }} className='p-1 mb-3'>
            <div>
              <div style={{ flex: 1 }} className=''>
                <div className='p-1 border-bottom' style={{ fontSize: 18, fontWeight: 600 }}>{v.progass_code}</div>
                <div style={{ height: 300, overflowY: 'auto' }}>
                  {learnareaData.map((vv, ii) => {
                    if (vv.progass_id != v.progass_id) {
                      return null
                    }
                    let selected_leranarea = acsFormData.learnarea_ids.findIndex((vvv) => vvv == vv.learnarea_id)
                    return <div key={ii} className='p-2 border-bottom d-flex flex-row cursor-pointer' onClick={() => {
                      if (selected_leranarea !== -1) {
                        acsFormData.learnarea_ids.splice(selected_leranarea, 1)
                      } else {
                        acsFormData.learnarea_ids.push(vv.learnarea_id)
                      }
                      this.setState({ acsFormData })
                    }}>
                      <div className='me-2'>
                        <FontAwesomeIcon icon={(selected_leranarea !== -1) ? faCheckCircle : faCircle} style={{ color: brand_colors[this.props.defaultTheme.theme_id].color4 }} />
                      </div>
                      <div className='d-flex flex-row flex-wrap'>
                        <div style={{ fontWeight: 600 }}>{vv.learnarea_code}</div> : {vv.learnarea_desc}
                      </div>
                    </div>
                  })}


                </div>
              </div>
            </div>
          </div>
        })}

      </div>
    </div>
  }

  renderSubjectStrands = () => {
    let { acsFormData } = this.state

    return <div>
      <h5>Subject Strands</h5>
      {acsFormData.gradebook_subjects.map((v, i) => {
        return <div key={i} className='d-flex flex-column mb-2 my-3 border p-2'>
          <div className='d-flex flex-row'>
            <Form.Group>
              <Form.Label>{t('Title')}</Form.Label>
              <Form.Control type="text"
                defaultValue={v.grs_title}
                onChange={(e) => this.setGradebookSubject(i, 'grs_title', e.target.value)} />
            </Form.Group>
          </div>
          <div>
            <Form.Group style={{ width: '100%' }}>
              <Form.Label>{t('Description')}</Form.Label>
              <Form.Control as="textarea" rows={2}
                defaultValue={v.grs_desc}
                onChange={(e) => this.setGradebookSubject(i, 'grs_desc', e.target.value)} />
            </Form.Group>
          </div>
          <div className='d-flex flex-row mt-2'>
            <Button variant='danger' size="sm" style={{ width: 100 }} onClick={() => {
              acsFormData.gradebook_subjects.splice(i, 1)
              this.setState({ acsFormData })
            }}>
              <FontAwesomeIcon icon={faTrash} />
            </Button>
          </div>
        </div>
      })}
      <div className='mt-3'>
        <Button variant='outline-info' style={{ width: '100%' }} onClick={() => {
          acsFormData.gradebook_subjects.push({
            grs_id: 0,
            grs_type: 'subject',
            grs_title: '',
            grs_desc: '',
          })
          this.setState({ acsFormData })
        }}>
          {'Add New'} {' '}
          <FontAwesomeIcon icon={faPlus} />
        </Button>
      </div>

    </div>
  }

  renderMarksPercentage = () => {
    let { acsFormData, examstypegrp } = this.state
    let term_linked_agegroup_assessment = acsFormData.term_linked_agegroup_assessment
    let termTotal = parseFloat(acsFormData.term_linked_agegroup_assessment.term_d_1) + parseFloat(acsFormData.term_linked_agegroup_assessment.term_d_2) + parseFloat(acsFormData.term_linked_agegroup_assessment.term_d_3) + parseFloat(acsFormData.term_linked_agegroup_assessment.term_d_4)
    let total_tlaa_d_percentage_1 = 0;
    let total_tlaa_d_percentage_2 = 0;
    let total_tlaa_d_percentage_3 = 0;
    let total_tlaa_d_percentage_4 = 0;

    return <div>
      <h5>{t('Grade Selection & Replication')}</h5>
      {this.state.editing &&
        <Row className='mb-3'>
          <Col className='pe-0 position-relative'>
            <button style={{
              fontSize: 10,
              fontWeight: 'bold',
              borderRadius: 10,
              position: 'absolute',
              right: 7,
              top: 7,
              zIndex: 9999,
            }}
              onClick={() => {
                this.setState({
                  acsFormData: {
                    ...acsFormData,
                    selectedGrades: this.props.AgeGroupData.map(item => {
                      return {
                        ...item,
                        value: item.agegroup_id,
                        label: item.agegroup_code
                      }
                    })
                  },
                });
              }}
              className='btn btn-sm btn-outline-success'>SELECT ALL</button>
            <Select
              placeholder={t('Select Grades')}
              isMulti={true}
              closeMenuOnSelect={false}
              value={this.state.acsFormData.selectedGrades}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({
                  ...base,
                  zIndex: 9999
                }),
                control: styles => ({
                  ...styles,
                  paddingRight: 75
                }),
              }}
              options={this.props.AgeGroupData?.map(item => {
                return {
                  ...item,
                  value: item.agegroup_id,
                  label: item.agegroup_code
                }
              })}
              onChange={(obj) => {
                this.setState({
                  acsFormData: {
                    ...acsFormData,
                    selectedGrades: obj
                  }
                });
              }}
            />
          </Col>
          <Col md={'auto'}>
            <Button disabled={acsFormData.selectedGrades.length == 0 || this.state.replicating} variant="success" size="sm" style={{ height: 38 }}
              onClick={() => this.setState({
                confirmAlert: {
                  show: true,
                  action: () => this.replicateMarksPercentage()
                }
              })}>{t('Replicate for Selected Grades')}
            </Button>
          </Col>
        </Row>
      }
      <hr />
      <h5>{t('Term Percentage Distribution')}</h5>
      <Table borderless>
        <thead>
          <tr>
            <th style={{ width: '16.66%', backgroundColor: '#f2f2f2' }}></th>
            <th style={{ width: '16.66%', backgroundColor: '#f2f2f2' }}>
              <div style={{ fontSize: 14, textAlign: 'center' }}>Term 1</div>
            </th>
            <th style={{ width: '16.66%', backgroundColor: '#f2f2f2' }}>
              <div style={{ fontSize: 14, textAlign: 'center' }}>Term 2</div>
            </th>
            <th style={{ width: '16.66%', backgroundColor: '#f2f2f2' }}>
              <div style={{ fontSize: 14, textAlign: 'center' }}>Term 3</div>
            </th>
            <th style={{ width: '16.66%', backgroundColor: '#f2f2f2' }}>
              <div style={{ fontSize: 14, textAlign: 'center' }}>Term 4</div>
            </th>
            <th style={{ width: '16.66%', backgroundColor: '#f2f2f2' }}></th>
          </tr>
          <tr>
            <th style={{ width: '16.66%' }}></th>
            <th style={{ width: '16.66%' }}>
              <InputGroup>
                <Form.Control placeholder={t('%')}
                  value={term_linked_agegroup_assessment.term_d_1}
                  onChange={(e) => this.setState({ acsFormData: { ...acsFormData, term_linked_agegroup_assessment: { ...term_linked_agegroup_assessment, term_d_1: e.target.value } } })} />
              </InputGroup>
            </th>
            <th style={{ width: '16.66%' }}>
              <InputGroup>
                <Form.Control placeholder={t('%')}
                  value={term_linked_agegroup_assessment.term_d_2}
                  onChange={(e) => this.setState({ acsFormData: { ...acsFormData, term_linked_agegroup_assessment: { ...term_linked_agegroup_assessment, term_d_2: e.target.value } } })} />
              </InputGroup>
            </th>
            <th style={{ width: '16.66%' }}>
              <InputGroup>
                <Form.Control placeholder={t('%')}
                  value={term_linked_agegroup_assessment.term_d_3}
                  onChange={(e) => this.setState({ acsFormData: { ...acsFormData, term_linked_agegroup_assessment: { ...term_linked_agegroup_assessment, term_d_3: e.target.value } } })} />
              </InputGroup>
            </th>
            <th style={{ width: '16.66%' }}>
              <InputGroup>
                <Form.Control placeholder={t('%')}
                  value={term_linked_agegroup_assessment.term_d_4}
                  onChange={(e) => this.setState({ acsFormData: { ...acsFormData, term_linked_agegroup_assessment: { ...term_linked_agegroup_assessment, term_d_4: e.target.value } } })} />
              </InputGroup>
            </th>
            <th style={{ width: '16.66%' }}>
              <div className='d-flex'>
                <div style={{ flex: 1, textAlign: 'center' }}>=</div>
                <div style={{
                  backgroundColor: (termTotal == 100) ? '#D7FFE8' : '#FCDEDE',
                  color: (termTotal == 100) ? '#48CF48' : '#F45959',
                  flex: 1,
                  padding: 5,
                  textAlign: 'center',
                  borderRadius: 5
                }}>{termTotal}%</div>
              </div>
            </th>
          </tr>
        </thead>
        <tbody>
          {term_linked_agegroup_assessment.details.map((v, i) => {
            total_tlaa_d_percentage_1 += parseFloat(v.tlaa_d_percentage_1)
            total_tlaa_d_percentage_2 += parseFloat(v.tlaa_d_percentage_2)
            total_tlaa_d_percentage_3 += parseFloat(v.tlaa_d_percentage_3)
            total_tlaa_d_percentage_4 += parseFloat(v.tlaa_d_percentage_4)
            let find_type = this.state.DDL_examstypegrp_types.find((vv) => vv.value == v.examstypegrp_type)
            let find_type2 = this.state.DDL_examstypegrp_types2.find((vv) => vv.value == v.examstypegrp_type2)
            return <tr>
              <td className='table-light py-3'>
                <div className='d-flex flex-column'>
                  <div className='d-flex flex-row align-items-center justify-content-between mb-2'>
                    <div>{v.examstype_name} ({v.examstypegrp_name})</div>
                    <FontAwesomeIcon icon={faTrash} style={{ color: brand_colors[this.props.defaultTheme.theme_id].color11 }} className='cursor-pointer' title={t('Remove')} onClick={() => {
                      acsFormData.term_linked_agegroup_assessment.details.splice(i, 1)
                      this.setState({ acsFormData })
                    }} />
                  </div>
                  <div className='d-flex flex-row'>
                    <span style={{ fontSize: 12, fontWeight: 'bold', backgroundColor: changeColorOpacity(find_type?.color, 0.2), color: find_type?.color, borderRadius: 7, padding: '0.1rem 0.5rem' }}>{v.examstypegrp_type}</span>
                    <span className='ms-1' style={{ fontSize: 12, fontWeight: 'bold', backgroundColor: changeColorOpacity(find_type2?.color, 0.2), color: find_type2?.color, borderRadius: 7, padding: '0.1rem 0.5rem' }}>{v.examstypegrp_type2}</span>
                  </div>
                </div>
              </td>
              <td className='table-light py-3'>
                <InputGroup>
                  <Form.Control placeholder={t('%')}
                    value={v.tlaa_d_percentage_1}
                    onChange={(e) => this.setTermLinkedAgegroupAssessmentDetail(i, 'tlaa_d_percentage_1', e.target.value)} />
                </InputGroup>
                <Form.Group >
                  <Form.Control type="text" placeholder={t('Comment')}
                    value={v.tlaa_d_comment_1}
                    onChange={(e) => this.setTermLinkedAgegroupAssessmentDetail(i, 'tlaa_d_comment_1', e.target.value)}
                  />
                </Form.Group>
              </td>
              <td className='table-light py-3'>
                <InputGroup>
                  <Form.Control placeholder={t('%')}
                    value={v.tlaa_d_percentage_2}
                    onChange={(e) => this.setTermLinkedAgegroupAssessmentDetail(i, 'tlaa_d_percentage_2', e.target.value)} />
                </InputGroup>
                <Form.Group>
                  <Form.Control type="text" placeholder={t('Comment')}
                    value={v.tlaa_d_comment_2}
                    onChange={(e) => this.setTermLinkedAgegroupAssessmentDetail(i, 'tlaa_d_comment_2', e.target.value)}
                  />
                </Form.Group>
              </td>
              <td className='table-light py-3'>
                <InputGroup>
                  <Form.Control placeholder={t('%')}
                    value={v.tlaa_d_percentage_3}
                    onChange={(e) => this.setTermLinkedAgegroupAssessmentDetail(i, 'tlaa_d_percentage_3', e.target.value)} />
                </InputGroup>
                <Form.Group>
                  <Form.Control type="text" placeholder={t('Comment')}
                    value={v.tlaa_d_comment_3}
                    onChange={(e) => this.setTermLinkedAgegroupAssessmentDetail(i, 'tlaa_d_comment_3', e.target.value)}
                  />
                </Form.Group>
              </td>
              <td className='table-light py-3'>
                <InputGroup>
                  <Form.Control placeholder={t('%')}
                    value={v.tlaa_d_percentage_4}
                    onChange={(e) => this.setTermLinkedAgegroupAssessmentDetail(i, 'tlaa_d_percentage_4', e.target.value)} />
                </InputGroup>
                <Form.Group>
                  <Form.Control type="text" placeholder={t('Comment')}
                    value={v.tlaa_d_comment_4}
                    onChange={(e) => this.setTermLinkedAgegroupAssessmentDetail(i, 'tlaa_d_comment_4', e.target.value)}
                  />
                </Form.Group>
              </td>
              <td className='table-light py-3'></td>
            </tr>
          })}

        </tbody>
        <tfoot>
          <tr>
            <th>{t('Total')}</th>
            <td>
              <div style={{
                backgroundColor: (total_tlaa_d_percentage_1 == 100) ? '#D7FFE8' : '#FCDEDE',
                color: (total_tlaa_d_percentage_1 == 100) ? '#48CF48' : '#F45959',
                flex: 1,
                padding: 5,
                textAlign: 'center',
                borderRadius: 5,
                fontWeight: 'bold'
              }}>{total_tlaa_d_percentage_1}%</div>
            </td>
            <td>
              <div style={{
                backgroundColor: (total_tlaa_d_percentage_2 == 100) ? '#D7FFE8' : '#FCDEDE',
                color: (total_tlaa_d_percentage_2 == 100) ? '#48CF48' : '#F45959',
                flex: 1,
                padding: 5,
                textAlign: 'center',
                borderRadius: 5,
                fontWeight: 'bold'
              }}>{total_tlaa_d_percentage_2}%</div>
            </td>
            <td>
              <div style={{
                backgroundColor: (total_tlaa_d_percentage_3 == 100) ? '#D7FFE8' : '#FCDEDE',
                color: (total_tlaa_d_percentage_3 == 100) ? '#48CF48' : '#F45959',
                flex: 1,
                padding: 5,
                textAlign: 'center',
                borderRadius: 5,
                fontWeight: 'bold'
              }}>{total_tlaa_d_percentage_3}%</div>
            </td>
            <td>
              <div style={{
                backgroundColor: (total_tlaa_d_percentage_4 == 100) ? '#D7FFE8' : '#FCDEDE',
                color: (total_tlaa_d_percentage_4 == 100) ? '#48CF48' : '#F45959',
                flex: 1,
                padding: 5,
                textAlign: 'center',
                borderRadius: 5,
                fontWeight: 'bold'
              }}>{total_tlaa_d_percentage_4}%</div>
            </td>
            <td></td>
          </tr>
        </tfoot>
      </Table>
      <Table borderless>
        <tr>
          <td style={{ backgroundColor: '#f2f2f2' }}>
            <div className='d-flex flex-row justify-content-end' style={{ backgroundColor: '#f2f2f2' }}>
              <div style={{ width: 400 }} className='me-1'>
                <Select
                  placeholder={t('-- Add New Row -- ')}
                  options={examstypegrp.data.filter((v, i) => {
                    let findUsed = term_linked_agegroup_assessment.details.find((vv, ii) => vv.examstype_id == v.examstype_id)
                    if (!findUsed) {
                      return v
                    }
                  })}
                  onChange={(obj) => this.setState({ examstypegrp: { ...examstypegrp, selected: obj } })}
                  value={examstypegrp.selected}
                  menuPortalTarget={document.body}
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 99999999999999 }) }}
                  formatOptionLabel={option => {
                    let find_type = this.state.DDL_examstypegrp_types.find((vv) => vv.value == option.examstypegrp_type)
                    let find_type2 = this.state.DDL_examstypegrp_types2.find((vv) => vv.value == option.examstypegrp_type2)
                    return <div>
                      <div>{option.examstype_name} ({option.examstypegrp_name})</div>
                      <span style={{ fontSize: 12, fontWeight: 'bold', backgroundColor: changeColorOpacity(find_type?.color, 0.2), color: find_type?.color, borderRadius: 7, padding: '0.1rem 0.5rem' }}>{option.examstypegrp_type}</span>
                      <span className='ms-1' style={{ fontSize: 12, fontWeight: 'bold', backgroundColor: changeColorOpacity(find_type2.color, 0.2), color: find_type2.color, borderRadius: 7, padding: '0.1rem 0.5rem' }}>{option.examstypegrp_type2}</span>
                    </div>
                  }}
                />
              </div>
              <Button variant="primary" onClick={() => {
                if (!examstypegrp.selected) {
                  toast['warning'](t('Please select Type first!'))
                  return false
                }
                acsFormData.term_linked_agegroup_assessment.details.push({ ...examstypegrp.selected, tlaa_d_percentage_1: '0.00', tlaa_d_percentage_2: '0.00', tlaa_d_percentage_3: '0.00', tlaa_d_percentage_4: '0.00', tlaa_d_comment_1: '', tlaa_d_comment_2: '', tlaa_d_comment_3: '', tlaa_d_comment_4: '', })
                this.setState({
                  acsFormData, examstypegrp: { ...examstypegrp, selected: null }
                })
              }}>
                <FontAwesomeIcon icon={faPlus} />
              </Button>

            </div>
          </td>
        </tr>
      </Table>
    </div>
  }

  replicateMarksDef = async () => {
    const { acsFormData } = this.state;

    console.log('acsFormData', acsFormData);
    console.log('selectedGrades', acsFormData.selectedGrades);

    this.setState({ replicating: true });

    if (this.replicateReq) {
      this.replicateReq.abort();
    }

    this.replicateReq = new AbortController();

    const fData = new FormData();
    fData.append('as_id', acsFormData.as_id);
    fData.append('acs_id', acsFormData.acs_id);
    fData.append('selected_grades', JSON.stringify(acsFormData.selectedGrades.map(item => item.agegroup_id)));
    fData.append('marks_definiation_data', JSON.stringify(acsFormData.gradeslevel));


    const res = await POST('academic-classmain-subject/replicate-marks-definition', fData, {
      signal: this.replicateReq.signal,
    });

    if (res.data.type) {

      toast.success(t(res.data.message));
      this.setState({
        replicating: false,
        confirmAlert: {
          show: false,
          action: () => null
        }
      });

    } else {
      // toast.error(t(res.data.message));
      handleFormErrors(res.data.data)
      this.setState({ replicating: false });
    }

  }

  replicateMarksPercentage = async () => {
    const { acsFormData } = this.state;

    console.log('acsFormData', acsFormData);
    console.log('selectedGrades', acsFormData.selectedGrades);

    this.setState({ replicating: true });

    if (this.replicateReq) {
      this.replicateReq.abort();
    }

    this.replicateReq = new AbortController();

    const fData = new FormData();
    fData.append('as_id', acsFormData.as_id);
    fData.append('acs_id', acsFormData.acs_id);
    fData.append('selected_grades', JSON.stringify(acsFormData.selectedGrades.map(item => item.agegroup_id)));
    fData.append('term_linked_agegroup_assessment', JSON.stringify(acsFormData.term_linked_agegroup_assessment));


    const res = await POST('academic-classmain-subject/replicate-marks-percentage', fData, {
      signal: this.replicateReq.signal,
    });

    if (res.data.type) {

      toast.success(t(res.data.message));
      this.setState({
        replicating: false,
        confirmAlert: {
          show: false,
          action: () => { }
        }
      });

    } else {
      // toast.error(t(res.data.message));
      handleFormErrors(res.data.data)
      this.setState({ replicating: false });
    }

  }

  /**
   * Render Component
   * @returns {HTMLElement}
   */
  render() {
    const { showAddEditForm, working, editing, academicClassmainSubjects, acsFormData, academicSubjectsList, limit, totalRecords, deleteModal, academicClassmainSubjectsDDL, formTabs } = this.state;
    const selectedClass = this.props.selectedClass;
    const defaultTheme = this.props.defaultTheme;

    const regionalStorageURL = getRegionalStorageURL(this.props.authData.centerData.tenant_id);

    return (
      <div>
        <div>
          {/* <NavBar /> */}
          {/* id='page-content' */}
          {/* <div> */}
          {/* <Header lite={true} heading={t('Subjects')} /> */}
          {/* have-load-more-btn */}
          {/* grey-section  */}
          <div className={(!this.props.hideHeader) ? 'has-pagination' : 'has-pagination'}>
            {!this.props.hideHeader &&
              <div className='grey-section-header'>
                <div className='d-flex align-items-center'>
                  <span style={{ fontWeight: 600, opacity: 0.8 }}>{t('Subjects')}</span>
                  <Badge className='d-flex align-items-center ms-3' bg='info'>{t('Subjects Total Sessions:')} {this.state.subjectsSessions}</Badge>
                </div>
                <div>
                  <Button onClick={() => this.handleAddEditFormOpen()} className='btn-sm btn-add' variant='success'>
                    {t('Add Subject')}{' '}
                    <FontAwesomeIcon icon={faPlus} color={brand_colors[this.props.defaultTheme.theme_id].color8} style={{ fontSize: 16, }} />
                  </Button>
                </div>
              </div>
            }
            <Row>
              {academicClassmainSubjects ? (
                <>
                  {academicClassmainSubjects.length > 0 ? (
                    <>
                      {academicClassmainSubjects.map((v, i) => {
                        // linkTo, linkToStates, cardImage, name, code, text1, text2, selected, actions, description, extraTexts, status

                        let actions = [
                          {
                            type: 'delete', name: 'Delete', image: require('../../assets/images/remove-red.png'), iconName: faTrash, iconColor: brand_colors[this.props.defaultTheme.theme_id].color9, onClick: () => this.setState({ deleteModal: { ...this.state.deleteModal, show: true, id: v.acs_id, action: this.delete } })
                          },
                          {
                            type: 'edit', name: 'Edit', image: require('../../assets/images/edit.png'), iconName: faEdit, iconColor: brand_colors[this.props.defaultTheme.theme_id].color9, onClick: () => this.handleAddEditFormOpen(true, v)
                          },
                        ];

                        if (this.props.location == 'lms') {
                          actions = [];
                        }

                        let data = {
                          allData: v,
                          parent: v.parent_acs_name,
                          name: v.acs_name,
                          code: v.acs_code,
                          status: (v.acs_status == 1) ? true : false,
                          mandatory: (v.acs_mandatory == 1) ? true : false,
                          linkTo: '/subject-actions',
                          onClick: () => this.props.setSubject(v),
                          cardImage: (v.acs_image) ? regionalStorageURL + this.props.authData.centerData.center_uuid + '/academic_classmain_subject/' + v.acs_image : require('../../assets/images/noimage.png'),
                          actions,
                        }
                        return <SubjectCard data={data} key={i} />
                      }
                      )}
                    </>
                  ) : (
                    <Col md={12} className='pt-5 pb-4 pb-0 d-flex align-items-center flex-column'>
                      {t('No Subjects Found')}
                    </Col>
                  )}
                </>
              ) : (
                <Col md={12} className='pt-5 pb-0 d-flex align-items-center justify-content-center flex-column' style={{ minHeight: 245 }}>
                  <Spinner as='span' animation='grow' size='lg' role='status' aria-hidden='true' className='mb-1' />
                  {t('Loading Subjects...')}
                </Col>
              )}
              <Paginate limit={limit} totalRecords={totalRecords} pageChange={this.getAcademicClassmainSubjects} />
            </Row>
          </div>
          {/* </div> */}
        </div>


        <Modal
          backdrop='static'
          keyboard={false}
          size={'xxl'}
          show={showAddEditForm}
          onHide={this.handleAddEditFormClose}>
          <Modal.Header closeButton>
            <Modal.Title>
              {editing ? t('Update Subject') : t('New Subject')} {': ' + acsFormData.name} ({this.state.centerlic_year})
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className='custom-styled-form p-0'>
            <Row>
              <Col md={3}>
                <div style={{
                  height: 'calc(100vh - 200px)',
                  overflow: 'auto',
                  backgroundColor: '#F5F5F5',
                  padding: '10px 0'
                }}>
                  {formTabs.data.map((tab, index) => (
                    <div
                      onClick={() => {
                        this.setState({ formTabs: { ...formTabs, active: tab } })
                      }}
                      className={formTabs.active.name == tab.name ? 'active' : ''}
                      style={{ padding: '15px 25px', cursor: 'pointer' }}
                      data-tab-name={tab.id}>
                      <FontAwesomeIcon icon={faCheckCircle} style={{
                        color: formTabs.active.id == tab.id ? '#5BBD4A' : '#DEDFE0',
                        marginRight: 10,
                        fontSize: 25,
                        position: 'relative',
                        top: 3
                      }} />{t(tab.name)}
                    </div>
                  ))}
                </div>
              </Col>
              <Col md={9}>
                <div style={{
                  height: 'calc(100vh - 200px)',
                  overflow: 'auto',
                  padding: '25px 15px 25px 5px'
                }}>
                  {formTabs.active.id == 'tab_information' &&
                    <div id="tab_information">
                      <h5>{t('Subject details')}</h5>
                      <div className="d-flex flex-row">
                        <div style={{ flex: 1 }} className="d-flex flex-column me-4">
                          <div className="d-flex flex-row align-items-center mb-3">
                            <Form.Group style={{ flex: 1 }} className='me-3'>
                              <Form.Label>
                                {t('Subject')}
                              </Form.Label>
                              <Select
                                classNamePrefix='custom-styled-select'
                                className='custom-select' options={academicSubjectsList.filter((v) => v.ab_id == this.props.ab_id)} onChange={this.onChangeAcademicSubject} value={acsFormData.subject} />
                            </Form.Group>
                            <Form.Group style={{ flex: 1 }}>
                              <Form.Label>
                                {t('Name')}
                              </Form.Label>
                              <Form.Control type='text' value={acsFormData.name} onChange={(event) => this.setAcsFormData('name', event.target.value)} />
                            </Form.Group>
                          </div>
                          <div className="d-flex flex-row align-items-center mb-3">
                            <Form.Group style={{ flex: 1 }} className='me-3'>
                              <Form.Label>
                                {t('Code')}
                              </Form.Label>
                              <Form.Control type='text' value={acsFormData.code} onChange={(event) => this.setAcsFormData('code', event.target.value)} />
                            </Form.Group>
                            <Form.Group style={{ flex: 1 }} className='me-3'>
                              <Form.Label>
                                {t('Sessions Per Week')}
                              </Form.Label>
                              <Form.Control type='number' min={0} value={acsFormData.sessionsPerWeek} onChange={(event) => this.setAcsFormData('sessionsPerWeek', event.target.value)} />
                            </Form.Group>
                            <Form.Group style={{ flex: 1 }} className='me-3'>
                              <Form.Label>
                                {t('Subject Total Grade')}
                              </Form.Label>
                              <InputGroup>
                                <Form.Control type='number' min={0} max={'100'} value={acsFormData.coefficient} onChange={this.onChangeCoeff} />
                                <InputGroup.Text id='basic-addon2'>Total: {(acsFormData.coefficient) ? (parseFloat(acsFormData.totalCoeff) + parseFloat(acsFormData.coefficient)) : acsFormData.totalCoeff}/100</InputGroup.Text>
                              </InputGroup>
                            </Form.Group>
                            <Form.Group style={{ flex: 1 }} >
                              <Form.Label>
                                {t('Credits')}
                              </Form.Label>
                              <InputGroup>
                                <Form.Control type='number' min={0} step={'0.1'} max={'100'} value={acsFormData.acs_credits} onChange={(event) => this.setAcsFormData('acs_credits', event.target.value)} />
                              </InputGroup>
                            </Form.Group>
                          </div>
                          <div className="d-flex flex-row align-items-center mb-3">
                            <Form.Group style={{ flex: 1 }} >
                              <Form.Label>
                                {t('URL')}
                              </Form.Label>
                              <Form.Control type='text' value={acsFormData.url} onChange={(event) => this.setAcsFormData('url', event.target.value)} />
                            </Form.Group>
                          </div>
                        </div>
                        <div style={{ width: 300 }}>
                          <Form.Group controlId='file3'>
                            <Form.Label>
                              {t('Image')}
                            </Form.Label>
                            <div style={{ flexDirection: 'column', }} className='pic-prev d-flex justify-content-center' >
                              <div style={{ borderRadius: 5, borderStyle: 'dashed', borderWidth: 1, borderColor: '#ced4da', height: 200, display: 'flex', overflow: 'hidden', }} >
                                {(acsFormData.image && acsFormData.image_prev) ? (
                                  <div
                                    className='d-flex justify-content-center align-items-center'
                                    style={{ flex: 1, position: 'relative', }}
                                  >
                                    <button
                                      style={{ padding: 3, border: 3, background: 'none', position: 'absolute', top: 0, right: 0, }}
                                      onClick={() => {
                                        this.setState({
                                          acsFormData: {
                                            ...acsFormData,
                                            image: '',
                                            image_prev: '',
                                            image_deleted: 0,
                                          }
                                        });
                                        this.image.current.value = null;
                                      }}
                                    >
                                      <FontAwesomeIcon icon={faTimesCircle} color='rgb(220, 53, 69)' style={{ fontSize: 20, }} />
                                    </button>
                                    <img src={acsFormData.image_prev} alt={t('Preview')} style={{ width: '100%', height: '100%', objectFit: 'center' }} />
                                  </div>
                                ) : (
                                  <button
                                    onClick={() => this.image.current.click()}
                                    style={{ background: 'none', border: 0, flex: 1, }}
                                  >
                                    <FontAwesomeIcon
                                      icon={faPlus}
                                      style={{ fontSize: 30, }}
                                    />
                                  </button>
                                )}
                              </div>
                              <Form.Control className='d-none' ref={this.image} type='file' onChange={this.previewFile} name='image' accept='.jpg, .jpeg, .png' />
                            </div>
                          </Form.Group>
                        </div>
                      </div>
                      <div className="d-flex flex-row align-items-center mb-3">
                        <Form.Group style={{ flex: 1 }}>
                          <Form.Label>
                            {t('Description')}
                          </Form.Label>
                          <Form.Control as='textarea' rows={6} value={acsFormData.description} onChange={(event) => this.setAcsFormData('description', event.target.value)} />
                        </Form.Group>
                      </div>
                      <hr />
                      <h5>{t('Subject settings')}</h5>
                      <div className="d-flex flex-row ">
                        <div style={{ flex: 1 }} className="d-flex flex-column me-3">
                          <div className='mb-3'>
                            <ButtonGroup style={{ width: '100%' }}>
                              <Button onClick={() => this.setAcsFormData('mandatory', 1)} variant={(acsFormData.mandatory) ? "primary" : "light"}>{t('Mandatory')}</Button>
                              <Button onClick={() => this.setAcsFormData('mandatory', 0)} variant={(!acsFormData.mandatory) ? "primary" : "light"}>{t('Elective')}</Button>
                            </ButtonGroup>
                          </div>
                          <div>
                            <Form.Group>
                              <Form.Check type='switch' checked={(acsFormData.status) ? true : false} onChange={() => this.setAcsFormData('status', !acsFormData.status)} label={t('Status')} />
                            </Form.Group>
                          </div>
                        </div>
                        <div style={{ flex: 1 }} className="d-flex flex-column me-3">
                          <div className='mb-3'>
                            <ButtonGroup style={{ width: '100%' }}>
                              <Button onClick={() => this.setAcsFormData('parent_acs_id_flag', 0)} variant={(!acsFormData.parent_acs_id_flag) ? "primary" : "light"}>{t('Main Subject')}</Button>
                              <Button onClick={() => this.setAcsFormData('parent_acs_id_flag', 1)} variant={(acsFormData.parent_acs_id_flag) ? "primary" : "light"}>{t('Focus Subject')}</Button>
                            </ButtonGroup>
                          </div>
                          {(acsFormData.parent_acs_id_flag == 1) &&
                            <Form.Group className='mb-1'>
                              <Form.Label>
                                {t('Main Subject')}
                              </Form.Label>
                              <Select className='custom-select' options={academicClassmainSubjectsDDL} onChange={(event) => this.setAcsFormData('parent_acs_id', event)} value={acsFormData.parent_acs_id} />
                            </Form.Group>
                          }
                        </div>
                        <div style={{ flex: 1 }} className="d-flex flex-column">
                          <Form.Group className='mb-3 form-switch-wrap'>
                            <Form.Check type='switch' checked={(acsFormData.report_card_appearance) ? true : false} onChange={() => this.setAcsFormData('report_card_appearance', !acsFormData.report_card_appearance)} label={t('Appear on Report Card')} />
                          </Form.Group>
                          <Form.Group className='form-switch-wrap'>
                            <Form.Check type='switch' checked={(acsFormData.specific_priority) ? true : false} onChange={() => this.setAcsFormData('specific_priority', !acsFormData.specific_priority)} label={t('Specific Priority')} />
                          </Form.Group>
                        </div>
                      </div>


                    </div>
                  }
                  {formTabs.active.id == 'tab_marks_percentage' &&
                    <div id="tab_marks_percentage">
                      {this.renderMarksPercentage()}
                    </div>
                  }
                  {formTabs.active.id == 'tab_marks_definition' &&
                    <div id="tab_marks_definition">
                      {this.renderGradeslevel()}
                    </div>
                  }
                  {formTabs.active.id == 'tab_subject_strands' &&
                    <div id="tab_subject_strands">
                      {this.renderSubjectStrands()}
                    </div>
                  }
                  {formTabs.active.id == 'tab_curriculum_strands' &&
                    <div id="tab_curriculum_strands">
                      {this.renderStrands()}
                    </div>
                  }
                </div>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer>
            <Button variant='secondary' onClick={this.handleAddEditFormClose}>
              {t('Close')}
            </Button>
            <Button
              disabled={working}
              variant='success'
              onClick={() => this.insert()}>
              {editing ? t('Update Subject') : t('Add Subject')} {working ? <Spinner as='span' animation='grow' size='sm' role='status' aria-hidden='true' /> : ''}
            </Button>
          </Modal.Footer>
        </Modal>


        <SweetAlert
          show={deleteModal.show}
          warning
          showCancel
          confirmBtnText={t('Yes, delete it!')}
          confirmBtnBsStyle='danger'
          title={(deleteModal.title) ? deleteModal.title : t('Are you sure?')}
          onConfirm={deleteModal.action}
          onCancel={() => this.setState({ deleteModal: { ...deleteModal, show: false, id: 0, action: () => { } } })}
          focusCancelBtn
        >
          {(deleteModal.desc) ? deleteModal.desc : t('Confirm Delete!')}
        </SweetAlert>

        <SweetAlert show={this.state.confirmAlert.show} warning showCancel confirmBtnText={t('Yes, replicate it!')} confirmBtnBsStyle='danger' title={t('Are you sure?')} onConfirm={this.state.confirmAlert.action} onCancel={() => this.setState({ confirmAlert: { ...this.state.confirmAlert, show: false, action: () => null } })} focusCancelBtn>
          {t('This function will replicate the records for the targeted subject(s) and Grade(s) if their Records are empty this Function is irrevocable. Edit should then be manual.')}
        </SweetAlert>
      </div >
    );
  }
}

const mapStateToProps = (state) => ({
  authData: state.auth.authData,
  selectedClass: state.selectedClass.data,
  defaultLanguage: state.language.defaultLanguage,
  defaultTheme: state.theme.defaultTheme,
});

const mapDispatchToProps = () => ({
  setSubject,
});
export default connect(mapStateToProps, mapDispatchToProps())(Subjects);
